module.exports = __webpack_public_path__ + "static/bg-azul-606b44b6e663bc3e782962ef773b7ba5.jpg";